import { render } from "./CookiesDropDown.vue?vue&type=template&id=ba87eb86&scoped=true&ts=true"
import script from "./CookiesDropDown.vue?vue&type=script&lang=ts"
export * from "./CookiesDropDown.vue?vue&type=script&lang=ts"

import "./CookiesDropDown.vue?vue&type=style&index=0&id=ba87eb86&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba87eb86"]])

export default __exports__